import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isGroupsEnabled() {
    const userConfiguration = getUserConfiguration();
    return userConfiguration.GroupsEnabled && !userConfiguration.SessionSettings.IsExplicitLogon;
}
